import React, { useContext } from "react";

import { DispatchContext } from "../../../context/domain/planning/DispatchContext";
import { WeeklyContext } from "../../../context/global/WeeklyContext";
import { LockClosed } from "../../../components/icons/svg/outline";

import { formatDate } from "../../../utils/datetime";

/**
 * Week strip header for the daily dispatch grid: weekday labels, dates, and a
 * lock icon when that day is dispatch-locked. Reads visible week days from
 * {@link WeeklyContext} and lock state from {@link DispatchContext}.
 *
 * @returns {JSX.Element}
 */
const DatesBar = () => {
  const { showWeekends, datesOfWeek } = useContext(WeeklyContext);
  const dispatchContext = useContext(DispatchContext);
  const dayDetails = dispatchContext?.dayDetails ?? null;

  const datesOfWeekStrs = datesOfWeek.map((date) =>
    formatDate(date, "MM-DD-YY")
  );

  return (
    <div
      className={`absolute -left-2 pl-2 w-[102%] grid ${showWeekends ? "grid-cols-7 min-w-dispatchWeekends" : "grid-cols-5 min-w-dispatch"} gap-0 bg-white border-b-2 border-gray-300 z-20`}
    >
      {datesOfWeek.map((date, index) => {
        const lockedForDay = Boolean(
          dayDetails?.find(
            (dayRow) => dayRow.date === formatDate(date, "YYYY-MM-DD")
          )?.locked
        );
        return (
          <div key={index} className="text-gray-900 text-sm text-center m-1 my-2">
            <p className="font-bold text-sm mb-0 mt-1 leading-3 uppercase">
              <span className="relative inline-block">
                {formatDate(date, "weekday")}
                {lockedForDay ? (
                  <LockClosed
                    className="absolute left-full top-1/2 ml-1 h-3.5 w-3.5 -translate-y-1/2 text-gray-700"
                    aria-label="Locked day"
                  />
                ) : null}
              </span>
            </p>
            <p className="text-sm mt-1 leading-3">{datesOfWeekStrs[index]}</p>
          </div>
        );
      })}
    </div>
  );
};

export default DatesBar;
